import { render, staticRenderFns } from "./CopyStakeStreamerFraudReportsView.vue?vue&type=template&id=875831e2&scoped=true&lang=pug"
import script from "./CopyStakeStreamerFraudReportsView.vue?vue&type=script&lang=ts"
export * from "./CopyStakeStreamerFraudReportsView.vue?vue&type=script&lang=ts"
import style0 from "./CopyStakeStreamerFraudReportsView.vue?vue&type=style&index=0&id=875831e2&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "875831e2",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCol } from 'vuetify/lib/components/VGrid';
import { VContainer } from 'vuetify/lib/components/VGrid';
import { VRow } from 'vuetify/lib/components/VGrid';
installComponents(component, {VCol,VContainer,VRow})
